import * as React from 'react';
import PropTypes from 'prop-types';
import Route from '../components/Route';
import wrapDisplayName from 'react-wrap-display-name';
import hoistStatics from 'hoist-non-react-statics';

var withActiveState = function withActiveState(WrappedComponent) {
  var WithActiveStateInner = function WithActiveStateInner(props, ref) {
    var url = props.url;

    if (!url) {
      return React.createElement(WrappedComponent, Object.assign({}, props, {
        active: false,
        ref: ref
      }));
    }

    var path = (typeof url === 'object' ? url.pathname : url) || '';
    var escapedPath = path.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
    return React.createElement(Route, {
      path: escapedPath,
      exact: true
    }, function (_ref) {
      var match = _ref.match;
      return React.createElement(WrappedComponent, Object.assign({}, props, {
        active: !!match,
        ref: ref
      }));
    });
  };

  WithActiveStateInner.displayName = wrapDisplayName(WrappedComponent, 'WithActiveState');
  var WithActiveState = React.forwardRef(WithActiveStateInner);
  WithActiveState.defaultProps = {
    url: undefined
  };
  WithActiveState.propTypes = {
    url: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };
  WithActiveState.WrappedComponent = WrappedComponent;
  return hoistStatics(WithActiveState, WrappedComponent);
};

export default withActiveState;